export const CARD_API_BASE_URL = "https://scanner.cardapi.io/cks";
export const CARD_API_TEST_BASE_URL = "https://testscanner.cardapi.io/cks";
// TODO: test is temporary, remove when production is ready
export const AMSTERDAM_PAS_PORTAL_BASE_URL = "https://uitpastest.cardapi.io";
export const AMSTERDAM_PAS_PORTAL_TEST_BASE_URL =
  "https://uitpastest.cardapi.io";
